module.exports = __webpack_public_path__ + "static/img/30 days.be23c8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30 days.png
// module id = mSl8
// module chunks = 1